export default
{
    errors: {
        insufficient_permissions: 'Insufficient permissions, contact your chief, please.',
    },

    queueManagement: {
        not_an_assistant: 'You have permissions to access this module. However, you have not been assigned as an assistant by the head of the study department yet.',
    },

    'entities': {
        'save': 'Save',
        'saving': 'Saving..',
        'saved': 'Saved',
        'error': 'Error',
        'send': 'Send',
        'close': 'Close',
        'czech': 'Czech',
        'english': 'English',
        'successfull_request': 'Sent successfully',
        'result_not_found': 'Result not found',
        'detail': 'Detail',
        'loading': 'Loading...',
        'download': 'Download',
        'export': 'Export',
        'section_in_progress': 'This section is in progress.',
        'couldnt_save_server': 'A server error occurred while saving.',
        'invalidDimensions':'The image must have minimum dimensions',
        'no_data': 'We could not retrieve any data, please try again later.',
        'description_cz': 'Description',
        'description_en': 'Description',
        'alert': 'Notify',
        'not_alert': 'Do not notify',
        'language_notice': 'Some modules are only in Czech',
        'logout': 'Logout',
    },

    'map': {
        'generator': {
            'map': 'Map',
            'alert': 'Choose a place you want to show from the menu or click on it on the map.',
            'building_select': 'Area',
            'floor_select': 'Floor',
            'place_select': 'Place',
            'iframe_code': 'Code for your webpage',
            'copy': 'Copy',
            'save_as_image': 'Save as image',
            'link_to_map': 'Link to the map',
            'open_map_tab': 'Open the link in a new window',
            'hide_HTML_code': 'Hide HTML code',
            'show_HTML_code': 'Show HTML code',
            'map_is_generating': 'Map is generating',
            'bad_url': 'The entered URL parameters contain a mistake and the map cannot be displayed.',
            'contact': `<a class="white--text" href="https://my.mendelu.cz/contact">Contact us please.</a>`,
            'not_negative': 'Negative value',
            'not_found': (ctx) => `A place <code>${ctx.named('placeName')}</code> was not found.`,
            'bigger_map': 'ZOOM IN MAP',
            'big':'Big (1920x1080)',
            'medium':'Medium (1280x720)',
            'small':'Small (860x640)',
            'own':'Own dimension',
            'width_in_pixels':'Width in pixels',
            'height_in_pixels':'Height in pixels',
            'cancel':'Cancel',
            'export':'Export'

        },
        'defaults': {
            'exterior': 'Exterior',
            'no_name': 'No name'
        },
        'legend': {
            'building_name': (ctx) => `Building ${ctx.named('building')}`,
            'floor_name': (ctx) => `, floor ${ctx.named('floor')}`,
        }
    },

    'support': {
        'headline': 'Problems and ideas',
        'message_type_input': 'Type of message',
        'email_input': 'E-mail (optional)',
        'description_input': 'Description',
        'file_drop_text': 'Drag files here or click',
        'file_drop_text_hover': 'Release files to upload',
        'file_delete_confirm':'Do you re ally want to delete this file permanently?',
        'urgent_checkbox': 'The solution is urgent (mark only if there is an urgent request)',
        'email_input_invalid': 'E-mail must be valid',
        'have_question': 'I have question',
        'have_idea': 'I have idea',
        'have_problem': 'I have problem',
        'uploaded_files': 'Uploaded files',
        'files_to_be_uploaded': 'Files to be uploaded',
        'file_will_be_deleted': 'will be deleted',
        'invalidFileType': 'The file must have type',
        'fileTooBig': 'The file is too big.',
        'or': 'or'
    },

    'news': {
        "uploading" : "Uploading a post",
        "uploaded" : "Uploaded",
        "news_title": "News title",
        "uploading_title" : "Uploading title",
        "uploading_additional" : "Uploading additional images",
        "images_title": "Images",
        "placeEN": "Location in English",
        "time": "Time of the event (optional)",

        "detail_hint": "If you enter a custom name for the location of the news, you must also enter the name in English. To enter the time of the news, you must first enter the date of the news item.",
        "additional_info": "Additional information",
        "confirm_cancel_upload": "Clicking 'OK' will delete all the images you are uploading.",
        "info_images": "The recommended size of uploaded images is up to 5 MB, the maximum limit is 15 MB. If your connection is slow, it may take longer to save images.",
        "info_images_upload": "If it takes too long to upload, check your internet connection speed and image size.",
        "notification_dialog_description": "Everyone who uses the My MENDELU mobile app will receive a notification. If you are sure you want to notify users, click on the \"Notify\" button. If you want to edit the news without notification, click \"Do not notify\".",
        "notification_dialog_title": "Save and notify users again?",
    },

    'gamification': {
        'subjects': 'Subjects',
        'subject': 'Subject',
        'add_subject': 'Add subject',
        'archive_subject': 'Archive subject',
        'archive': 'Archive',
        'edit_subject': 'Edit subject',
        'subject_name': 'Subject name',
        'subject_code': 'Subject code',
        'subject_code_info': 'Enter a unique subject code according to the official MENDELU designation (e.g., VA2). This code is used for unique identification within the system and for administrative purposes.',
        'subject_icon': 'Subject icon',
        'delete': 'Delete',
        'does_not_exist': 'does not exist',
        'delete_title_dialog': 'Confirm deletion?',
        'delete_warning_dialog': 'This action cannot be undone.',
        'cancel': 'Cancel',
        'save': 'Save',
        'edit': 'Edit',
        'loading': 'Loading',
        'search_subject': 'Search subject..',
        'confirm_archive_subject': 'The subject disappears from the list. Students\' results, attendance and evaluations are kept.',
        'name': 'Name',
        'code': 'Code',
        'admin': 'Admin',
        'action': 'Action',
        'selected': 'selected',
        'no_subjects': 'No subjects',
        'no_subjects_added': 'No subjects added yet',
        'no_data': 'No data',
        'academics': 'Academics',
        'search_academics': 'Search academics..',
        'show_academics_selected': 'Show only selected academics',
        'academic_gam_profile_info': 'This academic does not have a gamification account yet. Please provide the required information to create one. Without an account, the academic cannot be assigned to a subject.',
        'add_academic': 'Add academic',
        'academics_lead': 'Select academics who can lead seminars.',
        'academics_ids_error': 'The entered login does not belong to this user. The UIS IDs do not match.',
        'login_error': 'xlogin does not exist',
        'general_error': 'Error. Please try it again.',
        'connection_error': 'Connection error',
        'more_icons': 'More icons',
        'hide_icons': 'Hide icons',
        'edit_selection': 'Edit selection',
        'fullname': 'First and last name',
        'enter_login': 'Enter xlogin',
        'add': 'Add',
        'seminars': 'Seminars',
        'seminar': 'Seminar',
        'add_seminar': 'Add seminar',
        'create_seminar': 'Create seminar',
        'new_seminar': 'New seminar',
        'seminar_name': 'Seminar name',
        'search_seminar': 'Search seminar..',
        'no_seminars': 'No seminars',
        'no_seminars_added': 'No seminars added yet',
        'semester': 'Semester',
        'winter_semester': 'Winter semester',
        'summer_semester': 'Summer semester',
        'current_semester': 'current',
        'history_read_only': 'Historical period — data is read only.',
        'score': 'Score',
        'test_date': 'Submitted at',
        'configuration': 'Configuration',
        'activate_features_info': 'Activate the required features for this seminar.',
        'enable_qr_info': 'By turning on the switches, you enable the generation of a QR code to show your students during the class. They will scan it via the My MENDELU app, which will record their attendance and allow them to complete the test and evaluation (depending on what you activate).',
        'generate_qr_code': 'Generate QR code',
        'regenerate_qr_title': 'Regenerate QR code?',
        'regenerate_qr_warning': 'This lesson already has a test somebody joined. Generating a new QR code will affect:',
        'regenerate_qr_participants': 'participants: {count}',
        'regenerate_qr_submissions': 'submissions: {count}',
        'regenerate_qr_kept': 'Nothing is deleted, the records are moved to history. They are no longer visible in the lesson though, and the previous QR codes stop working.',
        'regenerate_qr_confirm': 'Regenerate',
        'click_to_view_preview': 'Click to preview',
        'attendance_and_evaluation': 'Attendance and evaluation',
        'attendance_date': 'Attendance date',
        'star_count': 'Star count',
        'rating': 'Rating',
        'update': 'Update',
        'attendance': 'Attendance',
        'evaluation': 'Evaluation',
        'attendance_activated': 'Attendance activated',
        'evaluation_activated': 'Evaluation activated',
        'test_activated': 'Test activated',
        'test_not_started': 'Test not started (start in the "Tests" tab below)',
        'test_started': 'Test started',
        'start_test': 'Start test',
        'stop_test': 'Stop test',
        'time_remaining': 'Time remaining',
        'full_name': 'Name',
        'rank': 'Rank',
        'points': 'Points',
        'success_rate': 'Success rate',
        'submitted_at': 'Submitted',
        'completed': 'Completed',
        'cancelled': 'Cancelled',
        'status': 'Status',
        'connected': 'Connected',
        'disconnected': 'Disconnected',
        'in_progress': 'In progress',
        'submitted': 'Submitted',
        'not_submitted': 'Not submitted',
        'error': 'Error',
        'no_info': 'No info',
        'user_status': 'User status',
        'no_users_available': 'No users available',
        'search_user': 'Search users..',
        'users': 'Users',
        'users_genitive': 'users',
        'test_results': 'Test results',
        'test': 'Test',
        'tests': 'Tests',
        'add_test': 'Add test',
        'create_new_test': 'Create new test',
        'search_test': 'Search test..',
        'edit_test': 'Edit test',
        'select_test': 'Select test',
        'test_selection': 'Test selection',
        'want_separate_qr_for_test': 'I want a separate QR code for the test',
        'separate_test': 'Separate test',
        'separate_test_info': 'If you want to test students, e.g., at the beginning of the lesson and record attendance and evaluation at the end, you can generate a separate QR code for the test.',
        'test_duration_min': 'Test duration (min)',
        'advanced_test_settings': 'Advanced test settings',
        'submission_grace_label': 'Submission grace',
        'join_window_label': 'Join window',
        'unit_seconds': 's',
        'unit_minutes': 'min',
        'default_value_hint': 'Default: {value} {unit}',
        'leave_empty_for_default': 'Leave empty to use the default',
        'window_out_of_range': 'Enter a value between {min} and {max}',
        'join_window_longer_than_test': 'The join window cannot be longer than the test duration',
        'no_tests': 'No tests',
        'no_tests_added': 'No tests added yet',
        'test_name': 'Test name',
        'test_icon': 'Test icon',
        'test_one_question': 'The test must contain at least one question.',
        'questions': 'Questions',
        'question': 'Question',
        'title_select_questions': 'Select questions',
        'save_selection': 'Save selection',
        'add_another_question': 'Add another question',
        'question_list_empty': 'No questions',
        'can_create_new_question': 'You can create a new question',
        'create_question': 'Create question',
        'newest': 'Newest first',
        'oldest': 'Oldest first',
        'alphabetical': 'Alphabetically',
        'last_changes': 'Last changes',
        'created_by': 'Created by',
        'created': 'Created',
        'add_question': 'Add question',
        'search_question': 'Search question..',
        'question_type': 'Question type',
        'question_count': 'Question count',
        'no_questions': 'No questions',
        'no_questions_added': 'No questions added yet',
        'new_question': 'New question',
        'question_help_text': 'You can navigate using the Tab or Shift+Tab keys when creating questions.',
        'question_text': 'Question text',
        'required': 'Required',
        'options': 'Options',
        'option': 'Option',
        'yes': 'Yes',
        'no': 'No',
        'have_question': 'I have a question',
        'dashboard_welcome_title': 'Welcome to Mendeluj!',
        'dashboard_welcome_subtitle': 'The testing and gamification module. Create quizzes for your students.',
        'login': 'Login',
        'type_of_question': 'Type of question',
        'one_right_answer': 'One right answer',
        'multiple_right_answers': 'Multiple right answers',
        'true_false': 'True/False',

        'to_subjects_btn': 'Go to subjects',
        'tutorial_heading': 'Instructions for use',
        'badges_headline': 'Badges',
        'image': 'Picture',
        'badge_name': 'Badge name',
        'new_category': 'New category',
        'edit_category': 'Edit category',
        'edit_badge': 'Edit badge',
        'input_warning': 'Enter a name for both languages',
        'test_question': 'Test question',
        'add_new_answer': 'Add another option',
        'test_info': 'To save the test, you must fill in the necessary information about the test. The information is filled in correctly if the warning colour changes from red to green and if no exclamation mark appears.',

        'adding_subject_headline': '1. Adding a subject',
        'creating_questions_headline': '2. Creating questions',
        'creating_test_headline': '3. Creating a test',
        'creating_seminar_headline': '4. Creating a seminar',
        'seminar_activation_headline': '5. Seminar activation',
        'adding_subject_paragraph': 'Create the subjects you teach.\n'+ 'Enter the xlogins of all employees who will manage the course.',
        'creating_questions_paragraph': 'Create and edit questions of different types (single correct answer, multiple correct answers, true/false). You can reuse the questions in different tests of the chosen subject.',
        'creating_test_paragraph': 'Create a new test for the selected subject, assign questions to it. Tests can be edited at any time if they are not active.',
        'creating_seminar_paragraph': 'Create a seminar associated with the selected subject. For each seminar, you can enable attendance, add a test, or enable evaluation. You can use any combination of these features.',
        'seminar_activation_paragraph': 'After activation, it is necessary to share a QR code with students, which they can use to enter attendance, evaluation, or join the test waiting room. The test itself must be run separately.',
        'allow':'Allow',
        'not_allow':'Not allow',
        'privacy_policy_headline': 'Privacy Policy',
        'privacy_policy_paragraph': 'I agree to the processing of my personal data by Mendel University in Brno for the purpose of managing results in knowledge tests and other functions of the My Mendel application. Detailed information on the processing of personal data can be found in',
        'privacy_policy_link': 'the privacy policy',
        'privacy_policy_settings': 'I agree to the processing of my personal data by Mendel University in Brno for the purpose of managing results in knowledge tests and other functions of the My Mendel application.',
        'privacy_policy_link_settings': 'More about the processing of personal data (GDPR) at MENDELU',
        'consent': 'Consent',
        'privacy_policy_settings_headline': 'Manage how we process your data within the application',
        'privacy_policy_settings_button': 'Privacy settings',
    },

    'iotSensors': {
        'dashboardTitle': 'Smart University',
        'detail_back_button':'List of rooms',
        'search': 'What room are you searching for?',
        'degree_celsius': '°C',
        'free_pcs': 'Free PCs',
        'projector': 'Projector',
        'whiteboard': 'Whiteboard',
        'floor': 'floor',
        'open': 'Open',
        'close': 'Close',
        'measurement_tech_list': 'List of technologies',
        'pc_list': 'List of computers',
        'software_list': 'Software list',
        'pc_occupied': 'Occupied',
        'pc_not_occupied': 'Free',
        'search_software': 'Which software are you looking for?',
        'search_pc': 'What computer are you looking for?',
        'search_category': 'What category are you looking for?',
        'no_match_for_software': 'Sorry, no software found here. Try searching for another one.',
        'no_match_for_computer': 'Sorry, no computer found here. Try searching for another one.',

        'roomTypes': {
            'all_rooms': 'All',
            'classroom_and_laboratory': 'Classrooms and laboratories',
            'study_room': 'Study rooms',
            'pc_rooms': 'Computer rooms',
        },
        'measurements': {
            'HUMIDITY': 'Humidity',
            'NOISE': 'Noise',
            'LIGHT_INTENSITY': 'Light Intensity',
            'OCCUPANCY': 'Occupancy',
            'WINDOW_STATE': 'Window state',
            'TEMPERATURE': 'Temperature',
        },
        'measurement_icons': {
            'HUMIDITY': 'opacity',
            'NOISE': 'record_voice_over',
            'LIGHT_INTENSITY': 'emoji_objects',
            'OCCUPANCY': 'groups',
            'OCCUPANCY_PCS': 'meeting_room',
            'WINDOW_STATE': 'window',
            'TEMPERATURE': 'thermostat',
        },
        'alert': {
            'success': 'The values are normal, you will feel good here',
            'warning': 'Some values are not great',
            'error': 'The values in this room are NOT appropriate',
          }
    },

    'markdown': {
        "link_address_heading": "Link address",
        "link_description": "Description of the link",
        "save_link": "Save the link",
        "final_markdown": "Resulting Markdown formatting",
        "tutorial_description1": "- for line indentation it is necessary to enter 2x spaces / enters",
        "tutorial_description2": "- to cancel styling it is necessary to mark the whole formatted section with special characters and press again the button whose styling you want to cancel",
        "tutorial_description3": "- for faster formatting you can use keyboard shortcuts like Ctrl + B for bold, Ctrl + I for italic",
        "no_text_selected": "No text selected",
        "incorrect_address": "Invalid address",
        "example_link_address": "https://link.cz",
        "bold": "Bold",
        "italic": "Italic",
        "strike": "Strike",
        "link": "Link",
        "subheading": "Subheading",
    },

    'time_picker': {
        "bad_time_format": "Bad format. Please enter the time in format 06:30",
        "bad_time_range": "The time is entered in the wrong range. Please enter a time in the range ",
        "required": "Required",
    }
}
